var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import './TvingSpinner.scss';
var TvingSpinner = function (_a) {
    var _b = _a.delay, delay = _b === void 0 ? 1000 : _b;
    var _c = __read(useState(!delay), 2), isShow = _c[0], setShow = _c[1];
    useEffect(function () {
        var timeoutKey = setTimeout(function () {
            setShow(true);
        }, delay);
        return function () {
            clearTimeout(timeoutKey);
        };
    }, [delay]);
    return isShow ? _jsx("div", { className: "spinner" }) : null;
};
export default React.memo(TvingSpinner);
